import { Action } from '@ngrx/store';
import { SummaryRecurrentListModel, SummaryRecurrentModel } from '../../models/summary-recurrent.model';

export enum RecurrentActionTypes {
  LoadRecurrents = '[Recurrents] Load Recurrents',
  LoadRecurrentsSuccess = '[Recurrents] Load Recurrents Success',
  LoadRecurrentsFailure = '[Recurrents] Load Recurrents Failure',
}

export class LoadRecurrents implements Action {
  readonly type = RecurrentActionTypes.LoadRecurrents;
  constructor(public payload: { filter: any }) { }
}

export class LoadRecurrentsSuccess implements Action {
  readonly type = RecurrentActionTypes.LoadRecurrentsSuccess;
  constructor(public payload: {
    items: SummaryRecurrentModel[];
    total: number;
    summary: SummaryRecurrentListModel;
  }) { }
}

export class LoadRecurrentsFailure implements Action {
  readonly type = RecurrentActionTypes.LoadRecurrentsFailure;
  constructor(public payload: { error: any }) { }
}

export type RecurrentActions =
  | LoadRecurrents
  | LoadRecurrentsSuccess
  | LoadRecurrentsFailure;
